import { useEffect, useRef, useState } from "react";
import Header from "../Header";
import PageTransition from "../../PageTransition";
import "./Branding.css";

import hiretaleImg from "../../assets/sample-blog-img.jpg";
import schnellImg from "../../assets/branding-schnell.webp";
import herietaleImg from "../../assets/branding-herietale.webp";
import schnellpdf from '../../assets/schnell.pdf'
import hireatlepdf from '../../assets/hireatle.pdf'
import morecardimg from '../../assets/more-card-img.png'
/* ================= DATA ================= */
const BRANDING_WORKS = [
  {
    title: "HIRETALE",
    desc: "A Technology Startup In Space Of Hiring",
    image: herietaleImg,
    pdf: hireatlepdf,
  },
  {
    title: "SCHNELL BUILDERS",
    desc: "Turnkey Construction Solutions",
    image: schnellImg,
    pdf: schnellpdf,
  },
  {
    image: morecardimg,
    comingSoon: true
  },
];

/* ================= RESPONSIVE COUNT ================= */
const getVisible = () => {
  if (window.innerWidth <= 768) return 1; // mobile
  return 2; // desktop & tablet (ONLY TWO)
};

export default function Branding() {
  const sliderRef = useRef(null);

  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(getVisible());
  const [hint, setHint] = useState(null);

  const isAnimating = useRef(false);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const touchStartX = useRef(0);

  const maxIndex = BRANDING_WORKS.length - visible;
  const isMobile = window.innerWidth <= 768;

  /* ================= RESET ================= */
  useEffect(() => {
    document.body.style.overflow = "auto";
    window.scrollTo(0, 0);
  }, []);

  /* ================= RESIZE ================= */
  useEffect(() => {
    const onResize = () => {
      const v = getVisible();
      setVisible(v);
      setIndex((i) => Math.min(i, BRANDING_WORKS.length - v));
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  /* ================= WHEEL (DESKTOP) ================= */
  useEffect(() => {
    if (isMobile) return;

    const onWheel = (e) => {
      e.preventDefault();
      if (isAnimating.current) return;

      if (e.deltaY > 0 && index < maxIndex) slideTo(index + 1);
      if (e.deltaY < 0 && index > 0) slideTo(index - 1);
    };

    window.addEventListener("wheel", onWheel, { passive: false });
    return () => window.removeEventListener("wheel", onWheel);
  }, [index, maxIndex, isMobile]);

  /* ================= CURSOR HINT ================= */
  useEffect(() => {
    if (isMobile) return;

    const move = (e) => {
      if (!sliderRef.current) return;
      const r = sliderRef.current.getBoundingClientRect();
      setHint(e.clientX > r.left + r.width / 2 ? "right" : "left");
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [isMobile]);

  /* ================= MOUSE DRAG ================= */
  const onMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.clientX;
  };

  const onMouseMove = (e) => {
    if (!isDragging.current || isAnimating.current) return;

    const delta = e.clientX - startX.current;
    if (delta > 80 && index > 0) {
      slideTo(index - 1);
      isDragging.current = false;
    }
    if (delta < -80 && index < maxIndex) {
      slideTo(index + 1);
      isDragging.current = false;
    }
  };

  const onMouseUp = () => {
    isDragging.current = false;
  };

  /* ================= TOUCH ================= */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(delta) < 60) return;

    if (delta < 0 && index < maxIndex) slideTo(index + 1);
    if (delta > 0 && index > 0) slideTo(index - 1);
  };

  /* ================= TAP ================= */
  const onClickSlide = (e) => {
    if (isMobile || isAnimating.current) return;

    const r = sliderRef.current.getBoundingClientRect();
    const mid = r.left + r.width / 2;

    if (e.clientX > mid && index < maxIndex) slideTo(index + 1);
    if (e.clientX < mid && index > 0) slideTo(index - 1);
  };

  /* ================= SLIDE ================= */
  const slideTo = (i) => {
    isAnimating.current = true;
    setIndex(i);
    setTimeout(() => (isAnimating.current = false), 700);
  };

  /* ================= OPEN PDF ================= */
  const openPdf = (pdf) => {
    window.open(pdf, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Header visible mode="normal" />

      <PageTransition>
        <main className="branding-page" style={{ marginTop: "12rem" }}>
          {/* ================= HERO ================= */}
          <section className="branding-hero">
            <h1>BRANDING</h1>
            <p>
              We Define Your Unique Identity, Voice, And Visual Presence
              To Build Lasting Recognition And Trust.
            </p>
          </section>

          {/* ================= SLIDER ================= */}
          <div
            ref={sliderRef}
            className="branding-slider"
            onClick={onClickSlide}
            onMouseDown={!isMobile ? onMouseDown : undefined}
            onMouseMove={!isMobile ? onMouseMove : undefined}
            onMouseUp={!isMobile ? onMouseUp : undefined}
            onMouseLeave={!isMobile ? onMouseUp : undefined}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            {/* {hint && (
              <div className={`cursor-hint ${hint}`}>
                {hint === "right" ? "Tap →" : "← Tap"}
              </div>
            )} */}

            <div
              className="branding-track"
              style={{
                transform: `translateX(-${index * (100 / visible)}%)`,
              }}
            >
             {BRANDING_WORKS.map((item, i) => (
  <div className="branding-card" key={i}>
    <div
      className="branding-image"
      style={{ backgroundImage: `url(${item.image})` }}
    />

    {item.title && item.pdf && (
      <button
        className="branding-cta"
        onClick={(e) => {
          e.stopPropagation();
          openPdf(item.pdf);
        }}
      >
        {item.title}
      </button>
    )}

    {item.desc && <span>{item.desc}</span>}
  </div>
))}

            </div>
          </div>
        </main>
      </PageTransition>
    </>
  );
}
